export default function slugify(title: string): string {
	return title
		.replace(/\s+/g, "-")
		.replace(/[^\w-]+/g, "")
		.replace(/_/g, "-")
		.replace(/--+/g, "-")
		.replace(/-$/g, "")
		.toLowerCase();
}
